import { castArray } from 'lodash'

/**
 * Set the current product.
 *
 * @param product
 * @return {Object}
 */
export function setProduct(product) {
  return {
    type: 'SET_PRODUCT',
    product
  }
}

/**
 * Sets the frames.
 *
 * @param frames
 * @return {Object}
 */
export function setFrames(frames) {
  return {
    type: 'SET_FRAMES',
    frames: castArray(frames)
  }
}

/**
 * Set selected frame.
 *
 * @param {Object} frame
 * @return {Object}
 */
export function setSelectedFrame(frame) {
  return {
    type: 'SET_SELECTED_FRAME',
    frame
  }
}

/**
 * Clear selected frame.
 *
 * @return {Object}
 */
export function clearSelectedFrame() {
  return {
    type: 'CLEAR_SELECTED_FRAME'
  }
}

/**
 * Add an uploaded image.
 *
 * @param {Object} image
 * @return {Object}
 */
export function addUploadedImage(image) {
  return {
    type: 'ADD_UPLOADED_IMAGE',
    image
  }
}

// TODO: ...
export function removeUploadedImage() {
  return {
    type: 'REMOVE_UPLOADED_IMAGE'
  }
}

/**
 * Set selected attribute.
 *
 * @param {string} attribute
 * @param {*} value
 * @return {Object}
 */
export function setSelectedAttribute(attribute, value) {
  return {
    type: 'SET_SELECTED_ATTRIBUTE',
    attribute,
    value
  }
}

/**
 * Fetch from back-end API.
 *
 * @param path
 * @return {Object}
 */
export function fetchFromAPI(path) {
  return {
    type: 'FETCH_FROM_API',
    path
  }
}

/**
 * Sets fatal error.
 *
 * @param {Error|null} error
 * @return {Object}
 */
export function setFatalError(error) {
  return {
    type: 'SET_FATAL_ERROR',
    error
  }
}
